// Internal
import { clearProductsInfo, fetchProductInfoAsync } from './actions';
import { normalizeProducts, DEFAULT_PRODUCTS_INFO_STATE } from './constants';
import { selectShopDepartment } from '../shop/actions';

// Constants
const productsInfo = (state = DEFAULT_PRODUCTS_INFO_STATE, { type, payload }) => {
  switch (type) {
    case selectShopDepartment.type:
    case clearProductsInfo.type: {
      return DEFAULT_PRODUCTS_INFO_STATE;
    }

    case fetchProductInfoAsync.event.start: {
      const currentStyleNumbers = state.productCodesBeingFetched;
      const updatedStyleNumbers = [...currentStyleNumbers, ...payload];
      return {
        ...state,
        productCodesBeingFetched: Array.from(new Set(updatedStyleNumbers))
      };
    }

    case fetchProductInfoAsync.event.success: {
      const { products: requestedProducts, requestedStyles } = payload;
      const products = normalizeProducts(requestedProducts);
      const productCodesBeingFetched = state.productCodesBeingFetched.filter(
        number => !requestedStyles.includes(number)
      );
      return {
        ...state,
        products: {
          ...state.products,
          ...products
        },
        productCodesBeingFetched
      };
    }

    case fetchProductInfoAsync.event.error: {
      const { styleNumbers: requestedStyleNumbers } = payload;
      const productCodesBeingFetched = state.productCodesBeingFetched.filter(
        number => !requestedStyleNumbers.includes(number)
      );

      return {
        ...state,
        productCodesBeingFetched
      };
    }

    default:
      return state;
  }
};

export default productsInfo;
